import { AppAxios } from "../../components/AppInit";
//import { modalError } from "../../components/MensajeError";

const onSuccess = (response) => {
  return response;
};

const onError = (error, showModal) => {
  if (showModal) {
    /*modalError(
      "Existen problemas de comunicación, por favor vuelva a intentar más tarde.",
      "¡Vaya! Algo salió mal",
      "Volver a cargar",
      () => {
        window.parent.postMessage(
          `redirect:${process.env.REACT_APP_VOLVER}`,
          "*"
        );
      }
    );*/
  }
  return Promise.reject(error.response || error.message);
};

const onBlock = (error, showModal) => {
  if (showModal) {
    /*modalError(
      "Alcanzaste el límite de intentos permitidos. Por favor, inténtalo más tarde ¡Gracias!",
      "Lo sentimos",
      "Volver",
      () => {
        window.parent.postMessage(
          `redirect:${process.env.REACT_APP_VOLVER}`,
          "*"
        );
      }
    );*/
  }
  return Promise.reject(error.response || error.message);
};

const request = (options) => {
  return AppAxios(options)
    .then(onSuccess)
    .catch((err) => {
      if (err.response && err.response.status === 429) {
        return onBlock(err, options.showErrorModal);
      } else {
        return onError(err, options.showErrorModal);
      }
    });
};

export default request;
